import { Image, Heading, Link, Box, Flex } from '@chakra-ui/react'
import Amplify from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import { LOGIN_MODE } from '../login.util'
import OrganizationListView from '../organization-list'
import {
  dataLayerTagManager,
  GA_CATEGORY_LOGIN,
  sectionDetailedTrack,
} from '../../../containers/repository/repo.utils'
import ActiveDirectoryInput from './activeDirectory.input'
import greneLogo from '../../../assets/images/grene-logo.png'
import { VIEW_MODE } from './../login.util'

export function ActiveDirectoryLogin({ setLoginViewMode }) {
  const [user, setuser] = useState(null)

  useEffect(() => {
    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        userPoolId: process.env.REACT_APP_ACTIVE_DIRECTORY_USER_POOL_ID,
        identityPoolId: process.env.REACT_APP_ACTIVE_DIRECTORY_IDENTITY_POOL_ID,
        userPoolWebClientId:
          process.env.REACT_APP_ACTIVE_DIRECTORY_WEB_NO_SECRETE_CLIENT_ID,
        region: process.env.REACT_APP_EMAIL_AWS_REGION,
      },
      Analytics: {
        disabled: true,
      },
    })
  }, [])

  const onValidationSuccess = () => {
    setLoginViewMode(VIEW_MODE.ORG)
  }

  return (
    <Box
      bg="white"
      boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
      borderRadius="20px"
      minW="28rem"
      padding="3em 0em"
      color="black"
    >
      <Flex
        flex={1}
        h="full"
        alignItems="center"
        justifyContent="center"
        flexDir="column"
        gap="1rem"
      >
        <Image src={greneLogo} maxW="64px" />
        <ActiveDirectoryInput
          onValidationSuccess={onValidationSuccess}
          setLoginMode={setLoginViewMode}
        />
      </Flex>
    </Box>
  )
}
